export const API_BASE = '/cards/api';

export async function apiFetch(path, options = {}) {
  const normalized = path.startsWith('/') ? path : `/${path}`;
  const url = path.startsWith('http') ? path : `${API_BASE}${normalized}`;
  return fetch(url, {
    credentials: 'same-origin',
    ...options,
  });
}